import { createReducer, on } from '@ngrx/store';
import { JobsFavoritesInterface, JobsStateInterface } from '../types';
import * as JobsDataActions from './actions';

export const initialState: JobsStateInterface = {
  isLoading: false,
  jobs: {
    data: [],
    meta: {
      pagination: {
        page: 0,
        pageSize: 0,
        pageCount: 0,
        total: 0,
      },
    },
  },
  error: '',
};

// jobfavorites does not require loading, since it's result is negligibale for the user
export const initialStateJobFavorites: JobsFavoritesInterface = {
  jobSlugs: null,
  error: '',
};

export const JobsReducers = createReducer(
  initialState,
  on(JobsDataActions.getJobsData, (state) => ({ ...state, isLoading: true })),
  on(JobsDataActions.getJobsDataSuccess, (state, action) => ({
    isLoading: false,
    jobs: {
      data: action.data ?? null,
      meta: action.meta ?? null,
    },
    error: '',
  })),
  on(JobsDataActions.getJobsDataFailure, (state, action) => ({
    ...state,
    isLoading: false,
    error: action.error,
  })),
  on(JobsDataActions.resetJobsData, () => ({
    ...initialState
  })),
);

export const JobsFavoritesReducers = createReducer(
  initialStateJobFavorites,
  on(JobsDataActions.getJobFavoritesData, (state) => ({ ...state })),
  on(JobsDataActions.getJobFavoritesDataSuccess, (state, action) => ({
    ...state,
    jobSlugs: action.jobSlugs,
  })),
  on(JobsDataActions.getJobFavoritesDataFailure, (state, action) => ({
    ...state,
    error: action.error,
  })),
  on(JobsDataActions.resetJobFavoritesData, () => ({
    ...initialStateJobFavorites
  })),
)

